export const API_OPTIONS = [
  ['coverages', 'Coverages'],
  ['claim-statuses', 'Claim Statuses'],
  ['patient-cost', 'Patient Cost Estimator'],
  ['payment-accuracy', 'Payment Accuracy'],
  ['all', 'All']
] as const;

export const ROLE_OPTIONS = ['Developer', 'Product', 'Architect', 'Admin', 'Other'] as const;

export const PERSONAL_EMAIL_DOMAINS = new Set([
  'gmail.com',
  'yahoo.com', 'yahoo.co.uk', 'yahoo.co.in', 'yahoo.ca',
  'hotmail.com', 'hotmail.co', 'hotmail.co.uk', 'hotmail.fr', 'hotmail.de', 'hotmail.it',
  'outlook.com', 'outlook.co', 'outlook.co.uk',
  'live.com', 'live.co.uk',
  'msn.com',
  'aol.com',
  'icloud.com', 'me.com', 'mac.com',
  'mail.com',
  'protonmail.com', 'proton.me',
  'zoho.com',
  'yandex.com', 'yandex.ru',
  'gmx.com', 'gmx.de',
  'inbox.com',
  'rediffmail.com',
]);

export const ACCORDION_CONTENT = {
  'Who Qualifies': [
    'Innovative organizations and teams that are ready to experiment with the API, validate real-world use cases, and collaborate closely by offering early insights that will influence the direction of API product development',
    'Existing customers with valid portal access and active Availity contracts'
  ],
  'What Do I Get': [
    'Early Access to the API',
    'Direct Influence on Product Direction',
    'Detailed API Documentation & Resources',
    'Opportunity to Validate Real Use Cases',
    'Participation in Exclusive Feedback Cycles'
  ],
  "What's Next After Submission?": [
    'Submission Review & Eligibility Check',
    'Confirmation & Onboarding Instructions',
    'Access Provisioning',
    'Start Exploring',
    'Participate in Feedback Cycles'
  ]
};

export const WHY_JOIN_ITEMS = [
  ['Try New APIs First', 'Be the first to access our API network.'],
  ['Give Feedback', 'Influence our roadmap to benefit your long-term goals.'],
  ['Limited Seats Available', 'Get exclusive access.']
] as const;
